import { isDevEnv, isTestEnv } from "Utils/requests";
import LogoProd from "pictures/norre-logo.svg?react";
import LogoTest from "pictures/norre-logo-test.svg?react";
import { styled } from "@mui/material";

export const NorreLogo = styled(
    isTestEnv() || isDevEnv() ? LogoTest : LogoProd,
)({});
